// @ts-ignore
import { flatten as _flatten } from 'flat'

export const flatten = (
    obj: Record<string, unknown>
): Record<string, string> => {
    return _flatten(obj)
}
